import { render, staticRenderFns } from "./AccountsReceivableModule.vue?vue&type=template&id=1c3cdbb2&"
import script from "./AccountsReceivableModule.vue?vue&type=script&lang=js&"
export * from "./AccountsReceivableModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports